export const manifest = {
  screens: {
    scr_n1eyty: { name: "Home", route: "/" },
  },
}
